import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1 -1.555 .832l-5.445 -3.63l-5.444 3.63a1 1 0 0 1 -1.55 -.72l-.006 -.112v-14a5 5 0 0 1 5 -5h4z","key":"svg-0"}]]

/**
 * IconBookmarkFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItYm9va21hcmsiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE0IDJhNSA1IDAgMCAxIDUgNXYxNGExIDEgMCAwIDEgLTEuNTU1IC44MzJsLTUuNDQ1IC0zLjYzbC01LjQ0NCAzLjYzYTEgMSAwIDAgMSAtMS41NSAtLjcybC0uMDA2IC0uMTEydi0xNGE1IDUgMCAwIDEgNSAtNWg0eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/bookmark-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBookmarkFilled = createReactComponent('filled', 'bookmark-filled', 'BookmarkFilled', __iconNode);

export default IconBookmarkFilled;